import { KubernetesCluster } from "@/services/cloudchipr.api";
import {
  HighchartsChartDataSeriesOption,
  HighchartsChartDataType,
} from "@/storybook/c8r-highcharts/common/utils/types/common";

export const kubernetesClustersHighchartsDataGenerator = (
  clusters: KubernetesCluster[] | null,
): HighchartsChartDataType => {
  if (!clusters || clusters.length === 0) {
    return {
      categories: [],
      series: [
        { name: "Idle", data: [], color: "#F44336" },
        { name: "Reserved", data: [], color: "#9E9E9E" },
      ],
    };
  }

  const baseData = clusters.map((cluster) => {
    const name = cluster.name ?? cluster.cluster_id ?? cluster.id;

    return {
      name,
      idle: cluster.idle_monthly_cost || 0,
      reserved: cluster.reserved_monthly_cost || 0,
    };
  });

  let displayData = baseData;

  if (baseData.length > 15) {
    const firstPart = baseData.slice(0, 14);
    const others = baseData.slice(14).reduce(
      (acc, cluster) => ({
        name: "Others",
        idle: acc.idle + cluster.idle,
        reserved: acc.reserved + cluster.reserved,
      }),
      { name: "Others", idle: 0, reserved: 0 },
    );

    displayData = [...firstPart, others];
  }

  const categories = displayData.map((item) => item.name);

  const idleSeries: HighchartsChartDataSeriesOption = {
    name: "Idle",
    color: "#F44336",
    data: displayData.map((item) => ({
      y: item.idle,
      rawValue: item.idle,
    })),
  };

  const reservedSeries: HighchartsChartDataSeriesOption = {
    name: "Reserved",
    color: "#9E9E9E",
    data: displayData.map((item) => ({
      y: item.reserved,
      rawValue: item.reserved,
    })),
  };

  return {
    categories,
    series: [idleSeries, reservedSeries],
  };
};
